import { makeStyles } from '@material-ui/core/styles';
import rciImage from '../../img/stock-photo.jpg';
import ahrqImage from '../../img/AHRQ-image.jpg';
import ahrqImage2 from '../../img/AHRQ-2-image.jpg';
import ashaImage from '../../img/ASHA-image.jpg';

const workClasses = makeStyles((theme) => ({
  rciImg: {
    backgroundImage:`url(${rciImage})`,
    backgroundRepeat: 'no-repeat',
    backgroundColor:
      theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    minHeight:300,
    borderRadius: 30,
  },

  ashaImg: {
    backgroundImage:`url(${ashaImage})`,
    backgroundRepeat: 'no-repeat',
    backgroundColor:
      theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    minHeight:300,
    borderRadius: 30,
  },

  ahrqImg: {
    backgroundImage:`url(${ahrqImage})`,
    backgroundRepeat: 'no-repeat',
    backgroundColor:
      theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    minHeight:300,
    borderRadius: 30,
  },


  ahrqImg2: {
    backgroundImage:`url(${ahrqImage2})`,
    backgroundRepeat: 'no-repeat',
    backgroundColor:
      theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    minHeight:300,
    borderRadius: 30,
  },

  tagYellow: {
    paddingLeft: 10,
    paddingRight: 10,
    paddingTop: 10,
    paddingBottom: 10,
    marginRight: 10,
    marginBottom: 5,
    display: 'inline-flex',
    backgroundColor: '#F8F3DF',
    color: '#555263',
  },

}));

export default workClasses